/**
 * Генерирует уникальный идентификатор запроса.
 * Использует `crypto.randomUUID()` — работает в Node.js, Edge Runtime и браузере.
 */
export const generateRequestId = (): string => crypto.randomUUID();
